import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function nationalCodeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    if (control.value !== undefined && control.value) {

      var nationalCode = control.value;
      switch (nationalCode) {
        case "0000000000":
        case "1111111111":
        case "2222222222":
        case "3333333333":
        case "4444444444":
        case "5555555555":
        case "6666666666":
        case "7777777777":
        case "8888888888":
        case "9999999999":
          return { nationalCode: false };
      }

      var chArray = nationalCode?.split('');
      var num0 = chArray[0] * 10;
      var num2 = chArray[1] * 9;
      var num3 = chArray[2] * 8;
      var num4 = chArray[3] * 7;
      var num5 = chArray[4] * 6;
      var num6 = chArray[5] * 5;
      var num7 = chArray[6] * 4;
      var num8 = chArray[7] * 3;
      var num9 = chArray[8] * 2;


      var a = chArray[9]
      var b = (((((((num0 + num2) + num3) + num4) + num5) + num6) + num7) + num8) + num9;
      var c = b % 11;

      if (!(((c < 2) && (a == c)) || ((c >= 2) && ((11 - c) == a))))
        return { nationalCode: false };


    }

    return null;

  }
}

